import React from 'react';
import { styled } from '@cp/ds/src/theme/styled';
import { Typography, TypographyProps } from '@cp/ds/src/components/typography';

const Root = styled(Typography, { name: 'PromocodeLabel' })(({ theme }) => ({
  backgroundColor: theme.palette.peach,
  color: theme.palette['gray dark'],
  padding: `${theme.spacing(0.25)} ${theme.spacing(1)}`,
  borderRadius: theme.borderRadius.small,
}));

export const PromocodeLabel = (props: TypographyProps) => <Root variant="extraSmall" {...props} />;
